// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreCustomer = (client) => ({
    /**
     * `GET /store/customers/me/bids`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomersMeBidsList
     * @source packages/medusa-plugin-auction-v2/src/api/store/customers/me/bids/route.ts
     */
    listMeBids: (query, headers) => client.fetch("/store/customers/me/bids", { method: "GET", query, headers }),
    /**
     * `GET /store/customers/me/cart-shares`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomersMeCartSharesList
     * @source apps/backend/src/api/store/customers/me/cart-shares/route.ts
     */
    listMeCartShares: (query, headers) => client.fetch("/store/customers/me/cart-shares", { method: "GET", query, headers }),
    /**
     * `GET /store/customers/me/addresses-gst`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomersMeAddressesGstRetrieve
     * @source apps/backend/src/api/store/customers/me/addresses-gst/route.ts
     */
    retrieveMeAddressesGst: (query, headers) => client.fetch("/store/customers/me/addresses-gst", { method: "GET", query, headers }),
    /**
     * `GET /store/customers/me/gst`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomersMeGstRetrieve
     * @source apps/backend/src/api/store/customers/me/gst/route.ts
     */
    retrieveMeGst: (query, headers) => client.fetch("/store/customers/me/gst", { method: "GET", query, headers }),
    /**
     * `GET /store/customers/me/phone`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomersMePhoneGet
     * @source apps/backend/src/api/store/customers/me/phone/route.ts
     */
    retrieveMePhone: (query, headers) => client.fetch("/store/customers/me/phone", { method: "GET", query, headers }),
    /**
     * `POST /store/customers/me/addresses/find-or-create`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomersMeAddressesFindOrCreateCreate
     * @source apps/backend/src/api/store/customers/me/addresses/find-or-create/route.ts
     */
    updateMeAddressesFindOrCreate: (body, query, headers) => client.fetch("/store/customers/me/addresses/find-or-create", { method: "POST", body, query, headers }),
    /**
     * `PUT /store/customers/me/addresses/:addressId/gst`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomersMeAddressesAddressidGstPut
     * @source apps/backend/src/api/store/customers/me/addresses/[addressId]/gst/route.ts
     */
    updateMeAddressesGst: (addressId, body, query, headers) => client.fetch(buildPath("/store/customers/me/addresses/:addressId/gst", [addressId]), { method: "PUT", body, query, headers }),
    /**
     * `PATCH /store/customers/me/applications`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomersMeApplicationsPatch
     * @source apps/backend/src/api/store/customers/me/applications/route.ts
     */
    updateMeApplication: (body, query, headers) => client.fetch("/store/customers/me/applications", { method: "PATCH", body, query, headers }),
    /**
     * `PUT /store/customers/me/gst`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomersMeGstPut
     * @source apps/backend/src/api/store/customers/me/gst/route.ts
     */
    updateMeGst: (body, query, headers) => client.fetch("/store/customers/me/gst", { method: "PUT", body, query, headers }),
    /**
     * `POST /store/customers/me/phone/verify-request`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomersMePhoneVerifyRequestPost
     * @source apps/backend/src/api/store/customers/me/phone/verify-request/route.ts
     */
    updateMePhoneVerifyRequest: (body, query, headers) => client.fetch("/store/customers/me/phone/verify-request", { method: "POST", body, query, headers }),
    /**
     * `POST /store/customers/me/phone/verify`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCustomersMePhoneVerifyPost
     * @source apps/backend/src/api/store/customers/me/phone/verify/route.ts
     */
    verifyMePhone: (body, query, headers) => client.fetch("/store/customers/me/phone/verify", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=customers.js.map